import { Badge, type BadgeColor } from '@clay-run/glaze/badge';
import type { CampaignPerformance, CampaignStatus } from '../performance-fixtures';

const COLORS: Record<CampaignStatus, BadgeColor> = {
  live: 'green',
  paused: 'yellow',
  ended: 'default',
};

export function campaignStatusLabel(c: CampaignPerformance) {
  if (c.status === 'ended') return `Ended · ran ${c.totalDays} days`;
  return `${c.status === 'live' ? 'Live' : 'Paused'} · day ${c.dayOfRun} of ${c.totalDays}`;
}

export function CampaignStatusBadge({ campaign }: { campaign: CampaignPerformance }) {
  return <Badge color={COLORS[campaign.status]}>{campaignStatusLabel(campaign)}</Badge>;
}

const META_STATUS: Record<string, { label: string; color: BadgeColor }> = {
  ACTIVE: { label: 'Active', color: 'green' },
  PAUSED: { label: 'Paused', color: 'yellow' },
  CAMPAIGN_PAUSED: { label: 'Campaign paused', color: 'yellow' },
  ADSET_PAUSED: { label: 'Ad set paused', color: 'yellow' },
  IN_PROCESS: { label: 'In review', color: 'default' },
  PENDING_REVIEW: { label: 'In review', color: 'default' },
  WITH_ISSUES: { label: 'With issues', color: 'red' },
  DISAPPROVED: { label: 'Disapproved', color: 'red' },
  ARCHIVED: { label: 'Archived', color: 'default' },
  DELETED: { label: 'Deleted', color: 'default' },
  DRAFT: { label: 'Draft', color: 'default' },
  COMPLETED: { label: 'Completed', color: 'default' },
  CANCELED: { label: 'Canceled', color: 'default' },
};

export function MetaStatusBadge({ effectiveStatus }: { effectiveStatus: string }) {
  const s = META_STATUS[effectiveStatus] ?? { label: effectiveStatus.toLowerCase().replace(/_/g, ' '), color: 'default' };
  return <Badge color={s.color}>{s.label}</Badge>;
}
